<template>
	<div
		:class="props.data.color == 'green' ? 'bg-accent-green' : 'bg-accent-blue'"
		class="text-center text-white py-8 md:py-16"
	>
		<div class="relative w-full flex flex-col items-left justify-center px-2 md:px-8 lg:px-16">
			<div
				class="text-vc-header-xl sm:text-vc-title-sm max-w-sm sm:max-w-xl lg:max-w-3xl text-left"
			>
				<div style="font-family: Gascogne Serial Medium; line-height: 1">
					{{ props.data.title }}
				</div>
			</div>

			<div class="flex flex-row-reverse w-full">
				<div
					class="pt-4 font-thin text-vc-body md:text-vc-header-sm max-w-sm md:max-w-lg lg:max-w-xl leading-tight text-right"
				>
					{{ props.data.text }}
				</div>
			</div>
			<div class="relative h-56 md:h-72 lg:h-96 rounded-2xl mt-4 overflow-hidden">
				<img
					:src="props.data.image"
					alt="Image description"
					class="w-full h-full object-cover"
					loading="lazy"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TextPhotoSectionComponent',
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	setup(props) {
		return {
			props
		}
	}
}
</script>
